import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_arrow_rig_black",
  "use": "icon-icon_arrow_rig_black-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-icon_arrow_rig_black\"><path d=\"m3.646 9.887 3.889-3.889-3.889-3.89a.5.5 0 0 1 .708-.707l4.242 4.243a.498.498 0 0 1 .13.227l.015.084v.085a.498.498 0 0 1-.145.311l-4.242 4.243a.5.5 0 0 1-.708-.707Z\" fill=\"#3D3E40\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol